import { DetailAprobacionModalForm } from "./DetailAprobacionModalForm"


const DetailAprobacionModalFormWrapper = () => {
    return (<DetailAprobacionModalForm />)
}

export {DetailAprobacionModalFormWrapper}